import React from 'react';
import { Link } from 'react-router-dom';
import { IconX, IconChevronRight } from '@tabler/icons-react';
import EarnDiamondsChecklist from './EarnDiamondsChecklist';
import './DiamondsPanel.css';

// Compact diamonds mini-dashboard opened from the nav diamond badge: balance,
// compact claim cards, and a link out to the full /diamonds page. The balance
// comes in as the real remaining-credits number; `rewardStatus` is the nav's
// prefetched getCreditRewardStatus result so the panel opens without a fetch.
const DiamondsPanel = ({ user, userCredits, rewardStatus, subtitle, onClose, onClaimed, variant = 'desktop' }) => {
  const balance = typeof userCredits === 'number' ? userCredits : '—';

  return (
    <div className={`diamonds-panel diamonds-panel--${variant}`} role="dialog" aria-label="Diamonds">
      <div className="diamonds-panel__header">
        <div className="diamonds-panel__headmain">
          <div className="diamonds-panel__balance">
            <span className="diamonds-panel__balance-num">{balance}</span>
            <span className="diamonds-panel__balance-label">💎 Diamonds</span>
          </div>
          {subtitle && <div className="diamonds-panel__subtitle">{subtitle}</div>}
        </div>
        <button
          type="button"
          className="diamonds-panel__close"
          onClick={onClose}
          aria-label="Close"
        >
          <IconX size={18} />
        </button>
      </div>

      <EarnDiamondsChecklist
        user={user}
        compact
        hideClaimed
        showHeader={false}
        onRewardClaimed={onClaimed}
        rewardStatus={rewardStatus}
      />

      <Link to="/diamonds" className="diamonds-panel__fulllink" onClick={onClose}>
        View full diamonds page
        <IconChevronRight size={16} />
      </Link>
    </div>
  );
};

export default DiamondsPanel;
